import { render, staticRenderFns } from "./PersonMove.vue?vue&type=template&id=32f62015&scoped=true"
import script from "./PersonMove.vue?vue&type=script&lang=js"
export * from "./PersonMove.vue?vue&type=script&lang=js"
import style0 from "@/assets/public.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./PersonMove.vue?vue&type=style&index=1&id=32f62015&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f62015",
  null
  
)

export default component.exports